// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RZ9d","image":"Header_image__1U8Sd","name":"Header_name__35fb_","info":"Header_info__cDb4j","infoRow":"Header_infoRow__1CnC9"};